const countries = [
    { code: 'US', name: 'United States', phone: '1' },
    { code: 'CA', name: 'Canada', phone: '1' },
    { code: 'AF', name: 'Afghanistan', phone: '93' },
    { code: 'AX', name: 'Aland Islands', phone: '358' },
    { code: 'AL', name: 'Albania', phone: '355' },
    { code: 'DZ', name: 'Algeria', phone: '213' },
    { code: 'AS', name: 'American Samoa', phone: '1' },
    { code: 'AD', name: 'Andorra', phone: '376' },
    { code: 'AO', name: 'Angola', phone: '244' },
    { code: 'AI', name: 'Anguilla', phone: '1' },
    { code: 'AQ', name: 'Antarctica', phone: '672' },
    { code: 'AG', name: 'Antigua & Barbuda', phone: '1' },
    { code: 'AR', name: 'Argentina', phone: '54' },
    { code: 'AM', name: 'Armenia', phone: '374' },
    { code: 'AW', name: 'Aruba', phone: '297' },
    { code: 'AU', name: 'Australia', phone: '61' },
    { code: 'AT', name: 'Austria', phone: '43' },
    { code: 'AZ', name: 'Azerbaijan', phone: '994' },
    { code: 'BS', name: 'Bahamas', phone: '1' },
    { code: 'BH', name: 'Bahrain', phone: '973' },
    { code: 'BD', name: 'Bangladesh', phone: '880' },
    { code: 'BB', name: 'Barbados', phone: '1' },
    { code: 'BY', name: 'Belarus', phone: '375' },
    { code: 'BE', name: 'Belgium', phone: '32' },
    { code: 'BZ', name: 'Belize', phone: '501' },
    { code: 'BJ', name: 'Benin', phone: '229' },
    { code: 'BM', name: 'Bermuda', phone: '1' },
    { code: 'BT', name: 'Bhutan', phone: '975' },
    { code: 'BO', name: 'Bolivia', phone: '591' },
    { code: 'BQ', name: 'Bonaire, Sint Eustatius & Saba', phone: '599' },
    { code: 'BA', name: 'Bosnia & Herzegovina', phone: '387' },
    { code: 'BW', name: 'Botswana', phone: '267' },
    { code: 'BV', name: 'Bouvet Island', phone: '55' },
    { code: 'BR', name: 'Brazil', phone: '55' },
    { code: 'IO', name: 'British Indian Ocean Territory', phone: '246' },
    { code: 'VG', name: 'British Virgin Islands', phone: '1' },
    { code: 'BN', name: 'Brunei', phone: '673' },
    { code: 'BG', name: 'Bulgaria', phone: '359' },
    { code: 'BF', name: 'Burkina Faso', phone: '226' },
    { code: 'BI', name: 'Burundi', phone: '257' },
    { code: 'KH', name: 'Cambodia', phone: '855' },
    { code: 'CM', name: 'Cameroon', phone: '237' },
    { code: 'CV', name: 'Cape Verde', phone: '238' },
    { code: 'KY', name: 'Cayman Islands', phone: '1' },
    { code: 'CF', name: 'Central African Republic', phone: '236' },
    { code: 'TD', name: 'Chad', phone: '235' },
    { code: 'CL', name: 'Chile', phone: '56' },
    { code: 'CN', name: 'China', phone: '86' },
    { code: 'CX', name: 'Christmas Island', phone: '61' },
    { code: 'CC', name: 'Cocos (Keeling) Islands', phone: '61' },
    { code: 'CO', name: 'Colombia', phone: '57' },
    { code: 'KM', name: 'Comoros', phone: '269' },
    { code: 'CG', name: 'Congo - Brazzaville', phone: '242' },
    { code: 'CD', name: 'Congo - Kinshasa', phone: '243' },
    { code: 'CK', name: 'Cook Islands', phone: '682' },
    { code: 'CR', name: 'Costa Rica', phone: '506' },
    { code: 'HR', name: 'Croatia', phone: '385' },
    { code: 'CU', name: 'Cuba', phone: '53' },
    { code: 'CW', name: 'Curaçao', phone: '599' },
    { code: 'CY', name: 'Cyprus', phone: '357' },
    { code: 'CZ', name: 'Czechia', phone: '420' },
    { code: 'CI', name: "Côte d'Ivoire", phone: '225' },
    { code: 'DK', name: 'Denmark', phone: '45' },
    { code: 'DJ', name: 'Djibouti', phone: '253' },
    { code: 'DM', name: 'Dominica', phone: '1' },
    { code: 'DO', name: 'Dominican Republic', phone: '1' },
    { code: 'EC', name: 'Ecuador', phone: '593' },
    { code: 'EG', name: 'Egypt', phone: '20' },
    { code: 'SV', name: 'El Salvador', phone: '503' },
    { code: 'GQ', name: 'Equatorial Guinea', phone: '240' },
    { code: 'ER', name: 'Eritrea', phone: '291' },
    { code: 'EE', name: 'Estonia', phone: '372' },
    { code: 'SZ', name: 'Eswatini', phone: '268' },
    { code: 'ET', name: 'Ethiopia', phone: '251' },
    { code: 'FK', name: 'Falkland Islands (Islas Malvinas)', phone: '500' },
    { code: 'FO', name: 'Faroe Islands', phone: '298' },
    { code: 'FJ', name: 'Fiji', phone: '679' },
    { code: 'FI', name: 'Finland', phone: '358' },
    { code: 'FR', name: 'France', phone: '33' },
    { code: 'GF', name: 'French Guiana', phone: '594' },
    { code: 'PF', name: 'French Polynesia', phone: '689' },
    { code: 'TF', name: 'French Southern Territories', phone: '262' },
    { code: 'GA', name: 'Gabon', phone: '241' },
    { code: 'GM', name: 'Gambia', phone: '220' },
    { code: 'GE', name: 'Georgia', phone: '995' },
    { code: 'DE', name: 'Germany', phone: '49' },
    { code: 'GH', name: 'Ghana', phone: '233' },
    { code: 'GI', name: 'Gibraltar', phone: '350' },
    { code: 'GR', name: 'Greece', phone: '30' },
    { code: 'GL', name: 'Greenland', phone: '299' },
    { code: 'GD', name: 'Grenada', phone: '1' },
    { code: 'GP', name: 'Guadeloupe', phone: '590' },
    { code: 'GU', name: 'Guam', phone: '1' },
    { code: 'GT', name: 'Guatemala', phone: '502' },
    { code: 'GG', name: 'Guernsey', phone: '44' },
    { code: 'GN', name: 'Guinea', phone: '224' },
    { code: 'GW', name: 'Guinea-Bissau', phone: '245' },
    { code: 'GY', name: 'Guyana', phone: '592' },
    { code: 'HT', name: 'Haiti', phone: '509' },
    { code: 'HN', name: 'Honduras', phone: '504' },
    { code: 'HK', name: 'Hong Kong', phone: '852' },
    { code: 'HU', name: 'Hungary', phone: '36' },
    { code: 'IS', name: 'Iceland', phone: '354' },
    { code: 'IN', name: 'India', phone: '91' },
    { code: 'ID', name: 'Indonesia', phone: '62' },
    { code: 'IR', name: 'Iran', phone: '98' },
    { code: 'IQ', name: 'Iraq', phone: '964' },
    { code: 'IE', name: 'Ireland', phone: '353' },
    { code: 'IM', name: 'Isle of Man', phone: '44' },
    { code: 'IL', name: 'Israel', phone: '972' },
    { code: 'IT', name: 'Italy', phone: '39' },
    { code: 'JM', name: 'Jamaica', phone: '1' },
    { code: 'JP', name: 'Japan', phone: '81' },
    { code: 'JE', name: 'Jersey', phone: '44' },
    { code: 'JO', name: 'Jordan', phone: '962' },
    { code: 'KZ', name: 'Kazakhstan', phone: '7' },
    { code: 'KE', name: 'Kenya', phone: '254' },
    { code: 'KI', name: 'Kiribati', phone: '686' },
    { code: 'XK', name: 'Kosovo', phone: '383' },
    { code: 'KW', name: 'Kuwait', phone: '965' },
    { code: 'KG', name: 'Kyrgyzstan', phone: '996' },
    { code: 'LA', name: 'Laos', phone: '856' },
    { code: 'LV', name: 'Latvia', phone: '371' },
    { code: 'LB', name: 'Lebanon', phone: '961' },
    { code: 'LS', name: 'Lesotho', phone: '266' },
    { code: 'LR', name: 'Liberia', phone: '231' },
    { code: 'LY', name: 'Libya', phone: '218' },
    { code: 'LI', name: 'Liechtenstein', phone: '423' },
    { code: 'LT', name: 'Lithuania', phone: '370' },
    { code: 'LU', name: 'Luxembourg', phone: '352' },
    { code: 'MO', name: 'Macao', phone: '853' },
    { code: 'MG', name: 'Madagascar', phone: '261' },
    { code: 'MW', name: 'Malawi', phone: '265' },
    { code: 'MY', name: 'Malaysia', phone: '60' },
    { code: 'MV', name: 'Maldives', phone: '960' },
    { code: 'ML', name: 'Mali', phone: '223' },
    { code: 'MT', name: 'Malta', phone: '356' },
    { code: 'MH', name: 'Marshall Islands', phone: '692' },
    { code: 'MQ', name: 'Martinique', phone: '596' },
    { code: 'MR', name: 'Mauritania', phone: '222' },
    { code: 'MU', name: 'Mauritius', phone: '230' },
    { code: 'YT', name: 'Mayotte', phone: '269' },
    { code: 'MX', name: 'Mexico', phone: '52' },
    { code: 'FM', name: 'Micronesia', phone: '691' },
    { code: 'MD', name: 'Moldova', phone: '373' },
    { code: 'MC', name: 'Monaco', phone: '377' },
    { code: 'MN', name: 'Mongolia', phone: '976' },
    { code: 'ME', name: 'Montenegro', phone: '382' },
    { code: 'MS', name: 'Montserrat', phone: '1' },
    { code: 'MA', name: 'Morocco', phone: '212' },
    { code: 'MZ', name: 'Mozambique', phone: '258' },
    { code: 'MM', name: 'Myanmar (Burma)', phone: '95' },
    { code: 'NA', name: 'Namibia', phone: '264' },
    { code: 'NR', name: 'Nauru', phone: '674' },
    { code: 'NP', name: 'Nepal', phone: '977' },
    { code: 'NL', name: 'Netherlands', phone: '31' },
    { code: 'NC', name: 'New Caledonia', phone: '687' },
    { code: 'NZ', name: 'New Zealand', phone: '64' },
    { code: 'NI', name: 'Nicaragua', phone: '505' },
    { code: 'NE', name: 'Niger', phone: '227' },
    { code: 'NG', name: 'Nigeria', phone: '234' },
    { code: 'NU', name: 'Niue', phone: '683' },
    { code: 'NF', name: 'Norfolk Island', phone: '672' },
    { code: 'KP', name: 'North Korea', phone: '850' },
    { code: 'MK', name: 'North Macedonia', phone: '389' },
    { code: 'MP', name: 'Northern Mariana Islands', phone: '1' },
    { code: 'NO', name: 'Norway', phone: '47' },
    { code: 'OM', name: 'Oman', phone: '968' },
    { code: 'PK', name: 'Pakistan', phone: '92' },
    { code: 'PW', name: 'Palau', phone: '680' },
    { code: 'PS', name: 'Palestine', phone: '970' },
    { code: 'PA', name: 'Panama', phone: '507' },
    { code: 'PG', name: 'Papua New Guinea', phone: '675' },
    { code: 'PY', name: 'Paraguay', phone: '595' },
    { code: 'PE', name: 'Peru', phone: '51' },
    { code: 'PH', name: 'Philippines', phone: '63' },
    { code: 'PN', name: 'Pitcairn', phone: '64' },
    { code: 'PL', name: 'Poland', phone: '48' },
    { code: 'PT', name: 'Portugal', phone: '351' },
    { code: 'PR', name: 'Puerto Rico', phone: '1' },
    { code: 'QA', name: 'Qatar', phone: '974' },
    { code: 'RO', name: 'Romania', phone: '40' },
    { code: 'RU', name: 'Russia', phone: '7' },
    { code: 'RW', name: 'Rwanda', phone: '250' },
    { code: 'RE', name: 'Réunion', phone: '262' },
    { code: 'WS', name: 'Samoa', phone: '685' },
    { code: 'SM', name: 'San Marino', phone: '378' },
    { code: 'SA', name: 'Saudi Arabia', phone: '966' },
    { code: 'SN', name: 'Senegal', phone: '221' },
    { code: 'RS', name: 'Serbia', phone: '381' },
    { code: 'SC', name: 'Seychelles', phone: '248' },
    { code: 'SL', name: 'Sierra Leone', phone: '232' },
    { code: 'SG', name: 'Singapore', phone: '65' },
    { code: 'SX', name: 'Sint Maarten', phone: '1' },
    { code: 'SK', name: 'Slovakia', phone: '421' },
    { code: 'SI', name: 'Slovenia', phone: '386' },
    { code: 'SB', name: 'Solomon Islands', phone: '677' },
    { code: 'SO', name: 'Somalia', phone: '252' },
    { code: 'ZA', name: 'South Africa', phone: '27' },
    { code: 'GS', name: 'South Georgia and the South Sandwich Islands', phone: '500' },
    { code: 'KR', name: 'South Korea', phone: '82' },
    { code: 'SS', name: 'South Sudan', phone: '211' },
    { code: 'ES', name: 'Spain', phone: '34' },
    { code: 'LK', name: 'Sri Lanka', phone: '94' },
    { code: 'BL', name: 'St. Barthélemy', phone: '590' },
    { code: 'SH', name: 'St. Helena', phone: '290' },
    { code: 'KN', name: 'St. Kitts & Nevis', phone: '1' },
    { code: 'LC', name: 'St. Lucia', phone: '1' },
    { code: 'MF', name: 'St. Martin', phone: '590' },
    { code: 'PM', name: 'St. Pierre & Miquelon', phone: '508' },
    { code: 'VC', name: 'St. Vincent & Grenadines', phone: '1' },
    { code: 'SD', name: 'Sudan', phone: '249' },
    { code: 'SR', name: 'Suriname', phone: '597' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen', phone: '47' },
    { code: 'SE', name: 'Sweden', phone: '46' },
    { code: 'CH', name: 'Switzerland', phone: '41' },
    { code: 'SY', name: 'Syria', phone: '963' },
    { code: 'ST', name: 'São Tomé & Príncipe', phone: '239' },
    { code: 'TW', name: 'Taiwan', phone: '886' },
    { code: 'TJ', name: 'Tajikistan', phone: '992' },
    { code: 'TZ', name: 'Tanzania', phone: '255' },
    { code: 'TH', name: 'Thailand', phone: '66' },
    { code: 'TL', name: 'Timor-Leste', phone: '670' },
    { code: 'TG', name: 'Togo', phone: '228' },
    { code: 'TK', name: 'Tokelau', phone: '690' },
    { code: 'TO', name: 'Tonga', phone: '676' },
    { code: 'TT', name: 'Trinidad & Tobago', phone: '1' },
    { code: 'TN', name: 'Tunisia', phone: '216' },
    { code: 'TR', name: 'Turkey', phone: '90' },
    { code: 'TM', name: 'Turkmenistan', phone: '993' },
    { code: 'TC', name: 'Turks & Caicos Islands', phone: '1' },
    { code: 'TV', name: 'Tuvalu', phone: '688' },
    { code: 'VI', name: 'U.S. Virgin Islands', phone: '1' },
    { code: 'UG', name: 'Uganda', phone: '256' },
    { code: 'UA', name: 'Ukraine', phone: '380' },
    { code: 'AE', name: 'United Arab Emirates', phone: '971' },
    { code: 'GB', name: 'United Kingdom', phone: '44' },
    { code: 'UM', name: 'United States Minor Outlying Islands', phone: '246' },
    { code: 'UY', name: 'Uruguay', phone: '598' },
    { code: 'UZ', name: 'Uzbekistan', phone: '998' },
    { code: 'VU', name: 'Vanuatu', phone: '678' },
    { code: 'VA', name: 'Vatican City', phone: '39' },
    { code: 'VE', name: 'Venezuela', phone: '58' },
    { code: 'VN', name: 'Vietnam', phone: '84' },
    { code: 'WF', name: 'Wallis & Futuna', phone: '681' },
    { code: 'EH', name: 'Western Sahara', phone: '212' },
    { code: 'YE', name: 'Yemen', phone: '967' },
    { code: 'ZM', name: 'Zambia', phone: '260' },
    { code: 'ZW', name: 'Zimbabwe', phone: '263' },
];
export const COUNTRY_OPTIONS = countries.map((country) => ({
    label: country.name,
    value: country.code,
}));
export const COUNTRY_CODES = countries.map((country) => country.code);
export const COUNTRY_PHONE_CODES = countries.map((country) => country.phone);
export const COUNTRY_PHONE_CODE_OPTIONS = countries.map((country) => ({
    label: `${country.name} (+${country.phone})`,
    value: country.phone,
}));
export const countryCodeSet = new Set(COUNTRY_CODES);
export const countryPhoneCodeSet = new Set(COUNTRY_PHONE_CODES);
export const UNITED_STATES_AND_CANADA_PHONE_CODE = '1';
